/**
 * Marca en la URL de impresion de la factura que ademas hay que imprimir la guia de envio.
 * Solo se agrega al abrir la impresion recien emitida la factura: la reimpresion normal de
 * la factura no lleva guia (para eso esta el boton de la lista) y el render del PDF que se
 * adjunta al correo de facturacion electronica tampoco, porque se hace sin este parametro.
 */
export const SHIPPING_GUIDE_QUERY_PARAM = "guide";

/** Ruta de la guia de envio de una factura, para reimprimirla por si sola. */
export const shippingGuideUrl = (invoiceId: string, autoPrint: boolean = true): string =>
    `/user/invoices/shipping-guide/${invoiceId}/${autoPrint ? "1" : "0"}`;
